export const CfrRoutes = {
    Save: "CFR/Save",
    GetCfr: "CFR/GetCfr",
    ChangeStatus: "CFR/ChangeStatus",
    UnlinkIncident: "CFR/UnlinkIncident",
    LinkToIncident: "CFR/LinkToIncident",
    UnlinkPscInspection: "CFR/UnlinkPscInspection",
    LinkToPscInspection: "CFR/LinkToPscInspection"
}